import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import TemplateForm from '../../components/templates/TemplateForm';
import { getTemplate, updateTemplate } from '../../api/client';

export default function TemplateEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    setLoadError(null);
    getTemplate(id)
      .then((data) => {
        if (!cancelled) {
          setInitialData({
            title: data?.title ?? '',
            description: data?.description ?? '',
            instructions: data?.instructions ?? '',
            requirements: Array.isArray(data?.requirements) ? data.requirements : [],
            tools: data?.tools ?? [],
          });
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setLoadError(err?.body?.message || err?.message || 'Failed to load template');
        }
      });
    return () => { cancelled = true; };
  }, [id]);

  const handleSubmit = async (payload) => {
    setSubmitError(null);
    setLoading(true);
    try {
      await updateTemplate(id, payload);
      navigate('/templates', { replace: true });
    } catch (err) {
      setSubmitError(err?.body?.message || err?.message || 'Failed to update template');
    } finally {
      setLoading(false);
    }
  };

  if (loadError) {
    return (
      <div>
        <h1 className="h4 mb-3">Edit template</h1>
        <div className="alert alert-danger py-2 small" role="alert">
          {loadError}
        </div>
        <button type="button" className="btn btn-outline-secondary" onClick={() => navigate('/templates')}>
          Back to templates
        </button>
      </div>
    );
  }

  if (!initialData) {
    return (
      <div className="d-flex align-items-center justify-content-center py-5">
        <span className="spinner-border text-primary" role="status" aria-hidden="true" />
      </div>
    );
  }

  return (
    <div>
      <h1 className="h4 mb-3">Edit template</h1>
      <p className="text-muted mb-4">Update template fields and tools.</p>
      <TemplateForm
        key={id}
        initialData={initialData}
        onSubmit={handleSubmit}
        loading={loading}
        error={submitError}
      />
    </div>
  );
}
